module.exports = __webpack_public_path__ + "img/legalxhcian_zjtqzyxt_logo.6e58d307.png";